import type { UnlockDialogOpenOptions } from './UnlockDialog.types';

type GetUnlockDialogOpenOptionsParams = Readonly<{
  // The event has specificGuests pages the current guest has not yet revealed
  // (`hasSpecificGuestsPages && !hasIdentity`), regardless of any password gate.
  hasUnrevealedSpecificGuestPages: boolean;
  // The specificGuests swap is what surfaced the unlock button — i.e. there is
  // no active password gate to pass first (see getButtonsVisibility).
  isSpecificGuestsOnlyUnlock: boolean;
}>;

/**
 * Maps the CTA visibility signals to the options the unlock dialog opens with.
 *
 * - No unrevealed specificGuests pages → plain unlock (password-only / generic).
 *   `offerFindInvite` stays false in the dialog, so it reloads after unlock as before.
 * - Unrevealed specificGuests pages → the flow must end in find-invite. Skip the
 *   password gate only when there is no active password gate (`isSpecificGuestsOnlyUnlock`);
 *   otherwise show the password step first and let the dialog chain into find-invite
 *   once `hasUnlocked` flips (UnlockForm's success refetches the CTA query).
 */
export const getUnlockDialogOpenOptions = ({ hasUnrevealedSpecificGuestPages, isSpecificGuestsOnlyUnlock }: GetUnlockDialogOpenOptionsParams): UnlockDialogOpenOptions => {
  if (!hasUnrevealedSpecificGuestPages) {
    return { displayFindInvite: true };
  }

  return {
    displayFindInvite: true,
    isSpecificGuestsUnlock: true,
    skipPasswordGate: isSpecificGuestsOnlyUnlock,
    successBehavior: 'reloadInPlace',
  };
};
